<script lang="ts">
	import { menu } from '@tools/Menu.svelte';
	import type { GlobalSettingsType } from '$lib/queries/GlobalSettingsQuery';
	import SmallMenuBlock from './SmallMenuBlock.svelte';
	import ChevronRight from '@icons/ChevronRight.svelte';
	import { menuContentInOut } from '$lib/animations/MenuTransitions';

	let {
		menus
	}: {
		menus: GlobalSettingsType['menus'];
	} = $props();
</script>

{#if menu.isMobile}
	<section>
		<ul in:menuContentInOut|global out:menuContentInOut|global>
			<li><a class="item text:h3" href="/kalender"><span>Kalender</span><ChevronRight /></a></li>
			{#each menus as submenu}
				<li>
					<button class="item text:h3" onclick={() => menu.click(submenu.id)}
						><span>{submenu.title}</span><ChevronRight /></button
					>
				</li>
			{/each}
		</ul>

		{#each menus[0]?.blocks as block, i}
			<SmallMenuBlock data={block} index={i} />
		{/each}
	</section>
{/if}

<style lang="scss">
	section {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}

	ul {
		flex: 1 0 auto;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		padding-inline-start: 0;
		margin-block: 0;
		list-style-type: none;
		padding-top: $gap4;
	}

	li {
		display: flex;
	}

	.item {
		padding: $gap4 var(--gutter);
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: $gap2;
		position: relative;
		text-decoration: none;

		&:hover {
			background-color: $colorNavBackground;
		}

		span {
			position: relative;
			z-index: 2;
		}

		:global(svg) {
			height: 0.428em;
			position: relative;
			z-index: 2;
		}
	}
</style>
